import { Component, Input, OnInit } from '@angular/core';
import { AlertController, PopoverController } from '@ionic/angular';
import { HelpContentComponent } from './help-content.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-help-popover',
  templateUrl: './help-popover.component.html',
  styleUrls: ['./help-popover.component.scss'],
})
export class HelpPopoverComponent implements OnInit {
  @Input() interface: 'popover' | 'alert' = 'popover';
  @Input() text: string;
  @Input() set useEvent(use: boolean | 'true' | 'false') {
    if (use === false || use === 'false') {
      this.myUseEvent = false;
    }
  }

  get useEvent() {
    return this.myUseEvent;
  }

  private myUseEvent = true;

  constructor(
    private popoverCtrl: PopoverController,
    private alertCtrl: AlertController
  ) {}

  ngOnInit() {}

  async showHelp(event: any) {
    let ctrl: any;
    if (this.interface === 'alert') {
      ctrl = await this.alertCtrl.create({
        message: this.text,
        buttons: [
          {
            text: 'Aceptar',
          },
        ],
      });
    } else {
      ctrl = await this.popoverCtrl.create({
        component: HelpContentComponent,
        event: this.useEvent ? event : undefined,
        componentProps: { text: this.text },
      });
    }

    ctrl.present();
  }
}
